import React from 'react'
import { Button, ButtonProps, styled } from '@mui/material'

const StyledMaxButton = styled(Button)`
  padding: 4px 8px;
  min-width: unset;
  height: auto;
  background: rgba(191, 255, 11, 0.2);

  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  font-feature-settings: 'ss01' on, 'case' on, 'calt' off;
`

export const MaxButton = (props: ButtonProps) => {
  return (
    <StyledMaxButton size="small" {...props}>
      Max
    </StyledMaxButton>
  )
}
